define([
	"csi/access/_base",
	"csi/access/access",
	"csi/access/full",
], function(csiAccess, access, full) {

	const componentAdminRoles = ["Component Administrator"];
	const componentEditRoles = componentAdminRoles.concat(["Component Editor"]);

	const leafFolderAdminRoles = ["Leaf Folder Administrator"];

	const retailProductAdminRoles = ["Retail Product Administrator"];
	const hierarchyAdminRoles = ["Hierarchy Administrator"];
	const hierarchyEditRoles = hierarchyAdminRoles.concat(["Hierarchy Editor", "Hierarchy Library Administrator"]);

	const skuAdminRoles = ["SKU Administrator"];

	csiAccess.addViewRoles({
		"_CS_Data": {
			"AllComponents": {
				"NewComponent": access(full(componentAdminRoles)),
				"Copy": access(full(componentAdminRoles)),
			},
			"AllRetailProductHierarchies": {
				"Copy": access(full(hierarchyAdminRoles), full(leafFolderAdminRoles)),
				"Delete": access(full(hierarchyAdminRoles)),
				"Edit": access(full(hierarchyEditRoles)),
				"NewProductHierarchy": access(full(hierarchyAdminRoles)),
				"NewProductHierarchyFolder": access(full(hierarchyAdminRoles), full(leafFolderAdminRoles)),
			},
			"AllRetailProducts": {
				"NewRetailProduct": access(full(retailProductAdminRoles)),
				"Copy": access(full(retailProductAdminRoles)),
				"MassSelectProductHierarchy": access(full(retailProductAdminRoles), full(hierarchyEditRoles)),
				"SelectProductHierarchy": access(full(retailProductAdminRoles), full(hierarchyEditRoles))
			},
		},
		"ProductHierarchyDetails": {
			"RetailProducts": {
				"AggregateRetailProducts": access(full(retailProductAdminRoles)),
				"MoveToProductHierarchy": access(full(retailProductAdminRoles)),
				"NewRetailProduct": access(full(retailProductAdminRoles)),
				"NewFromRetailProduct": access(full(retailProductAdminRoles)),
				"Remove": access(full(retailProductAdminRoles)),
			},
		},
		"ProductHierarchyLevel": {
			"RetailProducts": {
				"MoveToProductHierarchy": access(full(retailProductAdminRoles)),
				"Remove": access(full(hierarchyEditRoles), full(retailProductAdminRoles)),
			},
		},
		"RetailProduct": {
			"Variants": {
				"NewVariant": access(full(retailProductAdminRoles)),
				"Copy": access(full(retailProductAdminRoles)),
			},
			"RetailProductSKUs": {
				"NewRetailProductSKU": access(full(skuAdminRoles)),
				"Copy": access(full(skuAdminRoles)),
			},
		},
		"Variant": {
			"VariantComponents": {
				"NewVariantComponent": access(full(retailProductAdminRoles)),
				"Copy": access(full(retailProductAdminRoles)),
			},
		},
	});
});